import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { SectionHeading, EmptySection, Field, StatusBadge, formatDate } from './shared';

interface Props {
  data: any[];
}

const PRIORITY_COLORS: Record<string, string> = {
  low: 'bg-mozaic-green/15 text-mozaic-green',
  medium: 'bg-mozaic-orange/15 text-mozaic-orange',
  high: 'bg-mozaic-red/15 text-mozaic-red',
  critical: 'bg-mozaic-red/20 text-mozaic-red font-bold',
};

export default function ActionItemsSection({ data }: Props) {
  return (
    <section>
      <SectionHeading id="section-action-items" title="Action Items" count={data.length} />
      {data.length === 0 ? (
        <EmptySection name="action items" />
      ) : (
        <div className="mt-2 space-y-3">
          {data.map((row: any) => (
            <Card key={row.id}>
              <CardContent className="pt-4">
                <div className="mb-2 flex items-center gap-2">
                  <Badge className={PRIORITY_COLORS[row.priority] ?? 'bg-muted text-muted-foreground'}>
                    {row.priority}
                  </Badge>
                  <StatusBadge status={row.status} />
                </div>
                <p className="mb-3 text-sm font-medium">{row.description}</p>
                <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
                  <Field label="Assigned To" value={row.assigned_to_name} />
                  <Field label="Due Date" value={formatDate(row.due_date)} />
                  <Field label="Closed At" value={formatDate(row.closed_at)} />
                  {row.resolution_notes && (
                    <div className="col-span-full">
                      <Field label="Resolution Notes" value={row.resolution_notes} />
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
